import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-solid-svg-icons'

import { Box, Image } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useImage from '@hooks/useImage'

import type { ImageModel } from '@models/types'

interface UserImageProps {
  image: ImageModel,
}

const UserImage = (props: UserImageProps) => {
  const {
    image,
    image: { sort },
  } = props

  const {
    callbacks: {
      createOrEditImage,
    },
  } = useImage(image)

  const imageUrl = digObject(image, 'square_url', '')

  return (
    <Image
      borderRadius={5}
      forwardProps={{
        onClick: () => createOrEditImage(),
        style: { cursor: 'pointer' },
      }}
      url={imageUrl}
    >
      {sort === 0 && (
        <Box
          alignItems="flex-end"
          color="white"
          fontSize="small"
          height="100%"
          justifyContent="flex-end"
          padding="medium"
        >
          <FontAwesomeIcon icon={faStar} />
        </Box>
      )}
    </Image>
  )
}

export default UserImage
